var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9827 3.14578L14.6494 4.02041C16.4424 4.96136 17.339 5.43184 17.8368 6.27726C18.3346 7.12268 18.3346 8.1747 18.3346 10.2787V10.3762C18.3346 12.4802 18.3346 13.5323 17.8368 14.3777C17.339 15.2231 16.4424 15.6936 14.6494 16.6345L12.9827 17.5092C11.5197 18.2769 10.7882 18.6608 10.0013 18.6608C9.21441 18.6608 8.4829 18.2769 7.01988 17.5092L5.35321 16.6345C3.56016 15.6936 2.66363 15.2231 2.1658 14.3777C1.66797 13.5323 1.66797 12.4802 1.66797 10.3762V10.2787C1.66797 8.1747 1.66797 7.12268 2.1658 6.27726C2.66363 5.43184 3.56016 4.96136 5.35321 4.02041L7.01988 3.14578C8.4829 2.37802 9.21441 1.99414 10.0013 1.99414C10.7882 1.99414 11.5197 2.37802 12.9827 3.14578Z",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.5 6.57715L14.1667 8.24382M10 10.3271L2.5 6.57715M10 10.3271V18.2438M10 10.3271C10 10.3271 12.2855 9.18438 13.75 8.45215C13.9127 8.37079 14.1667 8.24382 14.1667 8.24382M14.1667 8.24382V11.1605M14.1667 8.24382L6.25 4.07715",
    stroke: "#858585",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsIcon);
export default __webpack_public_path__ + "static/media/ProductsIcon.633ab53aa36fefc29a6de8fd9964984d.svg";
export { ForwardRef as ReactComponent };